import axiosInstance from "../axios/axios";

export const AdminLoginApi = async (values: any) => axiosInstance.post('/hotel/login', values );
